import type { BoxProps } from '@mui/material'
import { Box, Typography } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'

import { COLORS } from '../../../constants'
import { unit } from '../../../utils'

type DividerWithLabelProps = PropsWithChildren & BoxProps & { component?: string }

export const DividerWithLabel: FC<DividerWithLabelProps> = ({ children, ...props }) => {
  return (
    <Box bgcolor={COLORS.hiekka[500]} paddingY={unit(3.5)} paddingX={unit(7)} {...props}>
      <Typography variant='uppercaseS'>{children}</Typography>
    </Box>
  )
}
